import jsPDF from 'jspdf';
import { createContext, useContext, useState } from 'react';

const ReportContext = createContext({ });

export const ReportProvider = ({ children }) => {
    const [printing, setPrinting] = useState(false);
    const [data, setData] = useState(null);
    const [dataReal, setDataReal] = useState(null);

    const handlePrint = (elementId) => {
        setPrinting(true);
        setTimeout(() => {
            let element = window.document.getElementById(elementId);
            if(element) {
                let child = element.querySelector('canvas');
                if(child) {
                    let pdf = new jsPDF('landscape', 'mm');
                    pdf.addImage(child.toDataURL('image/png', 10), 'png', 0, 0, 297, 210);
                    pdf.autoPrint();
                    window.open(pdf.output('bloburl'), '_blank');
                }
            }
            setPrinting(false);
        }, 1000);
    }

    return (
        <ReportContext.Provider value={{ handlePrint, printing, data, setData, dataReal, setDataReal }}>
            {children}
        </ReportContext.Provider>
    )
}

export default ReportContext;

export function useReport() {
    return useContext(ReportContext);
}
